import React from "react";
import { Box, Typography } from "@mui/material";

interface ErrorMessageProps {
  message?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message = "Faltan ingresar datos",
}) => {
  return (
    <Box
      sx={{
        backgroundColor: "#f8d7da",
        padding: 2,
        borderRadius: 1,
        border: "1px solid #f5c6cb",
        mt: 2,
      }}
    >
      <Typography variant="body1" sx={{ color: "#721c24" }}>
        {message}
      </Typography>
    </Box>
  );
};

export default ErrorMessage;
